module.exports = __webpack_public_path__ + "img/Monkey-Esport-Logo-Template.jpg";